import { Slot } from '@shared/interfaces/slot';
import { Component, Prop, Watch } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import FieldWrapper from '../field-wrapper/field-wrapper.vue';
import AbstractField from '@/app/modules/shared/components/forms/inputs/abstract-field/abstract-field';
import moment from 'moment';
import { VueSelecto } from 'vue-selecto';
import { ignoreElements } from 'rxjs/operators';

@Component({
  name: 'bpc-time-slot',
  components: {
    'bpc-field-wrapper': FieldWrapper,
    'vue-selecto': VueSelecto,
  },
})
export default class TimeSlot extends mixins(AbstractField) {
  $refs: {
    // resourceForm: InstanceType<typeof ResourceForm> & { saveEntity(): void };
    selecto: InstanceType<typeof VueSelecto> & {
      getSelectedTargets(): void;
      getSelectableElements(): void;
      setSelectedTargets(): void;
      selectedTargets;
      SelectoMethods;
    };
  };

  // PROPS
  // Show selection  summary
  @Prop({
    type: Boolean,
    default() {
      return false;
    },
  })
  readonly showSummary: boolean;

  // Position of selection summary Only 'bottom' or 'top'
  @Prop({
    type: String,
    default() {
      return 'bottom';
    },
  })
  readonly summaryPosition: string;

  // Display type of selection summary Only 'vertical' or 'horizontal'
  @Prop({
    type: String,
    default() {
      return 'bottom';
    },
  })
  readonly summaryDisplayType: string;

  @Prop({
    type: Array,
    default() {
      return [];
    },
  })
  readonly value: Slot[];

  // DATA
  public slots: Slot[] = [];
  public selectedSlots: Slot[] = [];

  // COMPUTED
  get slotDuration() {
    //return this.$store.getters['centerSettings/centerSettings']?.default_slot_duration || 30;
    return 60;
  }

  get startTime() {
    return this.$store.getters['centerSettings/centerSettings']?.default_start_hour;
  }

  get endTime() {
    return this.$store.getters['centerSettings/centerSettings']?.default_end_hour;
  }

  // LIFECYCLE
  mounted() {
    this.slots = this.generateSlots();
    this.selectedSlots = this.value;
  }

  // METHODS
  onSelect(e) {
    const addedSlots = e.added;
    const removedSlots = e.removed;
    const addedAndRemovedSlots = addedSlots.concat(removedSlots);
    //Toggle select
    addedAndRemovedSlots.forEach(el => {
      el.classList.toggle('selected');
    });
  }

  onSelectEnd(e) {
    const newSelectedSlots: Slot[] = [];
    //const allSelectedSlots = this.$refs.selecto.getSelectedTargets();
    const allSelectedSlots = this.$el.querySelectorAll('.selected');

    //update selectedSlots
    allSelectedSlots.forEach(el => {
      const day = el.getAttribute('data-day');
      const startTime = el.getAttribute('data-start-time');
      const endTime = el.getAttribute('data-end-time');

      const slotToSave: Slot = {
        day: day,
        start_time: startTime,
        end_time: endTime,
      };

      newSelectedSlots.push(slotToSave);
    });
    this.selectedSlots = newSelectedSlots;
  }

  generateSlots(): Slot[] {
    const startTime = moment(this.startTime, 'HH:mm').format('HH:mm');
    const endTime = moment(this.endTime, 'HH:mm').format('HH:mm');

    let startTimeFormated = moment(startTime, 'HH:mm');
    const endTimeFormated = moment(endTime, 'HH:mm');
    let minutesToSum = this.slotDuration;

    const slots = [];

    slots.push(
      this.generateDaySlots(
        startTimeFormated,
        startTimeFormated.clone().add(this.slotDuration, 'minutes'),
      ),
    );

    while (!startTimeFormated.isSameOrAfter(endTimeFormated)) {
      startTimeFormated = moment(startTimeFormated).add(this.slotDuration, 'minutes');
      minutesToSum += this.slotDuration;

      slots.push(
        this.generateDaySlots(
          startTimeFormated.clone(),
          startTimeFormated.clone().add(this.slotDuration, 'minutes'),
        ),
      );
    }
    return slots;
  }

  generateDaySlots(startTime, endTime) {
    const days = ['mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun'];
    const daySlots = days.reduce((dayAccumulator, day) => {
      dayAccumulator[day] = false;
      return dayAccumulator;
    }, {});
    daySlots['start_time'] = startTime.format('HH:mm');
    daySlots['end_time'] = endTime.format('HH:mm');

    return daySlots;
  }

  selectedSlotsByDay(day) {
    return this.selectedSlots.filter(slot => slot.day === day);
  }

  isSelected(day, startTime, endTime) {
    let isSelected = false;
    //Toggle select
    if (this.selectedSlots) {
      this.selectedSlots.forEach(slot => {
        if (slot.day === day && slot.start_time === startTime && slot.end_time === endTime) {
          isSelected = true;
        }
      });
    }

    return isSelected;
  }

  // WATCHERS
  @Watch('selectedSlots')
  onValueChange() {
    this.$emit('input', this.selectedSlots);
  }
}
